import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../../service/autenticacao/auth.service';
import { LaiFormFactory } from '../../../service/lai/lai-form-factory.service';
import { LaiService } from '../../../service/lai/lai.service';
import { ARQUIVOS_PERMITIDOS } from '../../../tools/Files';
import { ERRO_DADOS_NAO_GRAVADOS, OK_MANIFESTO_ENVIADO } from '../../../tools/Mensagens';
import { PAGINA_SUCESSO_FORM } from '../../../tools/URL';
import { LaiBaseComponent } from './common/lai-base.component';

@Component({
  selector: 'app-lai',
  templateUrl: './lai.component.html',
  styleUrls: ['./lai.component.css']
})
export class LaiComponent extends LaiBaseComponent {
  enviando = false;
  carregandoArquivos = false;
  private arquivosPendentes = 0;
  readonly extensoesPermitidas = ['pdf', 'jpeg', 'jpg', 'png', 'zip', 'm4a', 'mp3', 'mp4'];
  readonly tamanhoMaximoArquivo = 10 * 1024 * 1024;

  constructor(
    auth: AuthService,
    factory: LaiFormFactory,
    private service: LaiService,
    private router: Router
  ) {
    super(auth, factory);
  }

  submit() {
    if (this.enviando) {
      return;
    }

    this.sincronizarPrioridadePessoaIdosa();
    this.formSubmitted = true;
    this.form.markAllAsTouched();

    if (this.carregandoArquivos) {
      alert('Aguarde a conclusão da leitura dos anexos.');
      return;
    }

    if (this.form.invalid) {
      alert('Preencha os campos obrigatórios.');
      return;
    }

    this.enviando = true;
    const payload = this.criarPayload();

    this.service.enviar(payload).subscribe(retorno => {
      this.enviando = false;
      if (retorno) {
        alert(OK_MANIFESTO_ENVIADO);
        this.router.navigate([PAGINA_SUCESSO_FORM]).catch(function () {
          console.warn('Falha ao navegar para a página de sucesso');
        });
      } else {
        alert(ERRO_DADOS_NAO_GRAVADOS);
      }
    }, () => {
      this.enviando = false;
      alert(ERRO_DADOS_NAO_GRAVADOS);
    });
  }

  voltar() {
    window.history.back();
  }

  get caracteresRestantes(): number {
    const valor = this.form.get('descricaoDetalhada').value || '';
    return 5000 - valor.length;
  }

  get caracteresUtilizados(): number {
    const valor = this.form.get('descricaoDetalhada').value || '';
    return valor.length;
  }

  onArquivosComplementaresChange(event: Event) {
    this.carregarArquivos(event, this.anexosArray);
  }

  onAnexosRepresentanteChange(event: Event) {
    this.carregarArquivos(event, this.anexosRepresentanteLegalArray);
  }

  private carregarArquivos(event: Event, destino) {
    const input = event.target as HTMLInputElement;
    const arquivos = input.files ? Array.from(input.files) : [];
    destino.clear();
    destino.markAsTouched();
    destino.updateValueAndValidity();

    arquivos.forEach((arquivo: File) => {
      if (!this.arquivoValido(arquivo)) {
        return;
      }

      const reader = new FileReader();
      this.iniciarLeituraArquivo();
      reader.onload = () => {
        const conteudo = String(reader.result || '').split(',')[1] || '';
        destino.push(this.criarArquivoControl(arquivo, conteudo));
        destino.markAsTouched();
        destino.updateValueAndValidity();
        this.finalizarLeituraArquivo();
      };
      reader.onerror = () => {
        alert('Não foi possível ler o arquivo selecionado.');
        this.finalizarLeituraArquivo();
      };
      reader.readAsDataURL(arquivo);
    });

    input.value = '';
  }

  private criarArquivoControl(arquivo: File, conteudo: string) {
    return new FormGroup({
      nomeArquivo: new FormControl(`${this.normalizarNomeArquivo(arquivo.name)}/type=${arquivo.type || 'application/octet-stream'}`),
      conteudo: new FormControl(conteudo)
    });
  }

  private arquivoValido(arquivo: File): boolean {
    const partesNome = arquivo.name.split('.');
    const extensao = partesNome.length ? partesNome[partesNome.length - 1].toLowerCase() : '';
    if (this.extensoesPermitidas.indexOf(extensao) < 0) {
      alert('Tipo de arquivo não permitido.');
      return false;
    }
    if (arquivo.type && ARQUIVOS_PERMITIDOS.indexOf(arquivo.type) < 0) {
      alert('Tipo de arquivo não permitido.');
      return false;
    }
    if (arquivo.size > this.tamanhoMaximoArquivo) {
      alert('Tamanho máximo de arquivo permitido: 10MB.');
      return false;
    }
    return true;
  }

  private iniciarLeituraArquivo() {
    this.arquivosPendentes++;
    this.carregandoArquivos = true;
  }

  private finalizarLeituraArquivo() {
    this.arquivosPendentes = Math.max(0, this.arquivosPendentes - 1);
    this.carregandoArquivos = this.arquivosPendentes > 0;
  }

  private normalizarNomeArquivo(nome: string): string {
    return (nome || '').replace(/[\/\\]/g, '-').trim();
  }

  private sincronizarPrioridadePessoaIdosa() {
    const usuario: any = this.authService.usuarioDTO || {};
    this.form.get('prioridadePessoaIdosa').setValue(usuario.prioridadePessoaIdosa === true);
  }
}
